<template>
    <div class="container">
        <form @submit.prevent="changePassword" class="">
            <v-text-field
                prepend-icon="mdi-lock"
                v-model="oldPassword"
                name="password"
                required
                :placeholder="$t('Old Password')"
                type="password"
                autofocus
                autocomplete="current-password"
            />
            <v-text-field
                prepend-icon="mdi-lock"
                v-model="newPassword"
                name="password"
                required
                :placeholder="$t('New Password')"
                type="password"
            />
            <v-text-field
                prepend-icon="mdi-lock"
                v-model="newPasswordConfirmation"
                name="password"
                required
                :placeholder="$t('New Password Confirmation')"
                type="password"
            />

            <div class="button-pane">
                <v-btn
                    class="button-prime w-2"
                    type="submit"
                >{{ $t('Change Password') }}</v-btn>
                <v-btn
                    class="button-secondary w-2"
                    @click="home"
                >{{ $t('Cancel') }}</v-btn>
            </div>
        </form>

        <div v-if="error" class="message error">{{ error }}</div>
        <div v-if="message" class="message success">{{ message }}</div>
    </div>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";
import Vue from "vue";
import VueAxios from "vue-axios";
import router from '../../router';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.use(VueAxios, axios);

export default {
    name: "ChangePassword",
    data() {
        return {
            error: null,
            message: null,
            oldPassword: null,
            newPassword: null,
            newPasswordConfirmation: null,
        }
    },
    methods: {
        home() {
            router.push('syntax')
        },
        changePassword() {
            this.error = '';
            if (this.newPassword !== this.newPasswordConfirmation) {
                // show warning
                this.error = i18n.t('The new password does not match with its confirmation.');
                return false;
            }

            let data = new FormData();
            data.append('oldPassword', this.oldPassword);
            data.append('newPassword', this.newPassword);
            axios.post(
                'api/changeUserPassword',
                data
            )
                .catch(e => {
                    console.log(e);
                    if (e.response.status < 200 && e.response.status > 299) {
                        this.message = null
                        this.error = i18n.t('An unknown error occurred. Please try again later.')
                    }
                })

                .then((response) => {
                    if (response.data.success) {
                        this.message = i18n.t('Your password was changed successfully.');
                        this.error = null;
                    } else {
                        this.message = null;
                        this.error = response.data.message;
                    }
                });
        },
    }
}
</script>

<style scoped>

.container {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 30%;
    min-width: 600px;
    color: #666;
    text-align: center;

    padding: 32px;
    font-size: 15px;
}

.container form input[type="text"] {
    border-bottom: 1px solid var(--sc-blue-light);
    outline: none;
}

button.w-3 {
    width: 30%;
}
button.w-2 {
    width: 48%;
}
button {
    opacity: 1;
    margin: 2%;
    border-radius: 0;
}
.container form button:first-child {
    margin-left: 0 !important;
}
.container form button:last-child {
    margin-right: 0;
}
.button-pane {
    margin-top: 2vh;
}
.container form button.button-prime[type="submit"] {
    background-color: var(--sc-blue) !important;
    color: #fff;
    box-shadow: 1px 1px 6px grey;
}

.container form button.button-secondary {
    background-color: #fff;
    color: var(--sc-blue);
    box-shadow: 1px 1px 6px grey;
}

div.message {
    padding: 8px;
    margin-top: 16px;
    color: white;
}

</style>
<style>
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: none;
}

.container form .v-input:not(.v-input--switch) .v-input__slot {
    border-bottom: 1px solid var(--toolbar-select-underline-disabled);
}

input:focus, textarea:focus {
    outline: none !important;
}
</style>